import { DB } from "@p0security/frontend-core/react";
import type { OktaIntegration } from "@p0security/integrations-okta-shared/types";
import { AppPaths } from "@p0security/shared/routes/constants";
import { doc, getDoc } from "firebase/firestore";

import { TenantAwareLink } from "../../../../TenantAwareLink.tsx";
import type { AwsLoginInstaller } from "../../../types";
import { oktaProviderInstaller } from "./okta";

export type AwsFederatedLoginInstaller = NonNullable<
  AwsLoginInstaller["options"]["federated"]
>;

export const federatedLoginInstaller: AwsFederatedLoginInstaller = {
  // Move to Okta option if we add additional providers in the future
  prerequisiteMessages: async ({ tenantId }) => {
    const okta = await getDoc(doc(DB, `o/${tenantId}/integrations/okta`));
    if (
      !Object.values(
        (okta?.data() as OktaIntegration | undefined)?.listing ?? {}
      ).find((i) => i.state === "installed")
    )
      return (
        <div>
          Requires installed{" "}
          <TenantAwareLink to={`${AppPaths.Integrations}/okta/listing`}>
            Okta directory listing component
          </TenantAwareLink>
        </div>
      );
  },
  items: {
    provider: {
      options: {
        okta: oktaProviderInstaller,
      },
    },
  },
};
